import { render, staticRenderFns } from "./JourneyItem.vue?vue&type=template&id=42d7a18d&lang=pug&"
import script from "./JourneyItem.vue?vue&type=script&lang=js&"
export * from "./JourneyItem.vue?vue&type=script&lang=js&"
import style0 from "./JourneyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports